import { jsx as o } from "react/jsx-runtime";
import { BaseDatePicker as s } from "../BaseDatePicker.js";
const m = ({ onDayClick: e, ...r }) => /* @__PURE__ */ o(s, { mode: "single", onDayClick: (n, i, t) => {
  e && (n.setHours(12), e(n, i, t));
}, ...r });
export {
  m as InlineDatePicker
};
//# sourceMappingURL=InlineDatePicker.js.map
